import { Component } from '@angular/core';
import { ApiService } from "../../services/api.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-xp-company-files',
  templateUrl: 'xp-company-files.html',
})
export class XpCompanyFilesPage {

  public data: any = [
    {
      company_file_id: '0',
      title: 'Bestanden',
      items: [
        {
          company_file_id: -1,
          title: 'Handleidingen',
          download_url: '',
          items: [
            {
              company_file_id: -10,
              title: 'Handleiding ATAG i-Serie',
              download_url: 'https://mijninstallatiepas.nl/assets/xprnz/atag-i-serie-nl.pdf',
              items: []
            },
            {
              company_file_id: -11,
              title: 'Handleiding ATAG P-Serie',
              download_url: 'https://mijninstallatiepas.nl/assets/xprnz/atag-p-serie-nl.pdf',
              items: []
            },
            {
              company_file_id: -12,
              title: 'Handleiding ATAG Q-Serie',
              download_url: 'https://mijninstallatiepas.nl/assets/xprnz/atag-q-serie-nl.pdf',
              items: []
            },
            {
              company_file_id: -13,
              title: 'Handleiding ATAG QR-Serie',
              download_url: 'https://mijninstallatiepas.nl/assets/xprnz/atag-qr-serie-nl.pdf',
              items: []
            },
          ]
        },
        {
          company_file_id: -4,
          title: 'Kenniskaart Koolmonoxidemelders en koolmonoxidestops aanbrengen',
          download_url: 'https://mijninstallatiepas.nl/assets/xprnz/kenniskaart-koolmonoxidemelders.pdf',
          items: []
        },
        {
          company_file_id: -5,
          title: 'ROGAFA Beugelvoorschrift - Het nieuwe beugelen!',
          download_url: 'https://mijninstallatiepas.nl/assets/xprnz/rogafa-beugelvoorschrift.pdf',
          items: []
        },
        {
          company_file_id: -6,
          title: 'Techniek Nederland - 10-puntenkaart CO-certificering',
          download_url: 'https://mijninstallatiepas.nl/assets/xprnz/techniek-nederland-controlepunten.pdf',
          items: []
        }
      ]
    }
  ];
  public expanded:any = [];

  constructor(
    public api: ApiService,
    public iab: InAppBrowser
  ) {
  }

  public ionViewDidEnter() {
    console.log('ionViewDidLoad CompanyFilesPage');
  }

  public itemClick(event, item){
    event.stopPropagation();
    if(item.download_url){
      this.iab.create(item.download_url, '_system');
    } else {
      this.toggleExpanded(item)
    }
  }

  public downloadFile(item){
    if(item.download_url){
      this.iab.create(item.download_url, '_system');
    }
  }

  public isExpanded(item){
    let id = item.company_file_id.toString();
    if(id == '0'){
      return true;
    }
    return (this.expanded.indexOf(id) > -1);
  }

  public toggleExpanded(item){
    let id = item.company_file_id.toString();
    console.log('toggle: ' + id);
    if(this.isExpanded(item)){
      let index = this.expanded.indexOf(id);
      if(index > -1){
        this.expanded.splice(index, 1);
      }
    } else {
      this.expanded.push(id);
    }
    console.log(this.expanded);
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-company-files/xp-company-files.ts